export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";
export const GAME_ID = process.env.REACT_APP_GAME_ID || "";
export const MLB_PLAYER_AVATAR_IMAGES = process.env.REACT_APP_MLB_PLAYER_AVATAR_IMAGES || "";
export const MLB_PLAYER_SHOT_IMAGES = process.env.REACT_APP_MLB_PLAYER_SHOT_IMAGES || "";
export const MLB_PLAYER_FULL_IMAGES = process.env.REACT_APP_MLB_PLAYER_FULL_IMAGES || "";
export const STORAGE_VERSION = 1;
export const IS_LOC = window.location.href.includes(".loc");
export const IS_BACKDOOR = JSON.parse(process.env.REACT_APP_IS_BACKDOOR || "false") as boolean;
export const SKIP_ERROR_CHECKING = process.env.REACT_APP_SKIP_ERROR_CHECKING === "true";
export const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || "";
export const IS_PROD = process.env.REACT_APP_ENVIRONMENT === "production";
export const IS_SECRET = process.env.REACT_APP_IS_SECRET === "true";

export const INSIGHTS_VIEW_URL = process.env.REACT_APP_INSIGHTS_VIEW_URL || "";
